import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface DraftFileFieldProps {
  label: string;
  pathValue: string;
  onPathChange: (path: string) => void;
  blobUrl?: string;
  onFileChange: (file: File) => void;
  accept?: string;
  labelClassName?: string;
}

export const DraftFileField = ({
  label,
  pathValue,
  onPathChange,
  blobUrl,
  onFileChange,
  accept = '.fbx',
  labelClassName,
}: DraftFileFieldProps) => (
  <div className="space-y-1">
    <Label className={cn('text-[#999]', labelClassName)}>{label}</Label>
    <div className="flex gap-2">
      <input
        type="file"
        accept={accept}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (!file) return;
          onFileChange(file);
          onPathChange(file.name);
        }}
        className="text-xs text-[#CCC] flex-shrink-0"
      />
      <Input
        value={pathValue}
        onChange={(e) => onPathChange(e.target.value)}
        className="bg-[#2A2A2A] border-[#444] text-[#E8E8E8] text-xs"
        placeholder="storage/path/model.fbx"
      />
    </div>
    {blobUrl && (
      <div className="text-xs text-[#C3D82E]">✓ File loaded for preview</div>
    )}
  </div>
);
